import React from 'react';

const ErrorPageConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/error',
			exact: true,
			component: React.lazy(() => import('./ErrorPage')),
		},
	],
};

export default ErrorPageConfig;
